import { Grid, SingleSelect } from "designSystem/index";
import { itemsInChinese } from "designSystemLegacy/data";
import React from "react";

export default () => {
	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<SingleSelect
					allowPinyin
					options={itemsInChinese}
					required
					value={itemsInChinese[0]}
				/>
			</Grid>
		</Grid>
	);
};